// Note: Don't use ":" char inside strings, it's reserved as a namespace

export var EMPTY_GROUP = "EMPTY_GROUP";
export var EMPTY_RULE_GROUP = "EMPTY_RULE_GROUP";
export var EMPTY_QUERY = "EMPTY_QUERY";
export var EMPTY_CASE = "EMPTY_CASE";
export var NO_CONFIG_FOR_FIELD = "NO_CONFIG_FOR_FIELD";
export var NO_CONFIG_FOR_OPERATOR = "NO_CONFIG_FOR_OPERATOR";
export var FIXED_OPERATOR = "FIXED_OPERATOR";
export var NO_CONFIG_FOR_FUNCTION = "NO_CONFIG_FOR_FUNCTION";
export var INVALID_VALUE = "INVALID_VALUE";
export var INVALID_FUNC_ARG_VALUE = "INVALID_FUNC_ARG_VALUE";
export var UNSUPPORTED_FIELD_TYPE = "UNSUPPORTED_FIELD_TYPE";
export var UNSUPPORTED_OPERATOR_FOR_FIELD = "UNSUPPORTED_OPERATOR_FOR_FIELD";
export var INVALID_VALUE_SRC = "INVALID_VALUE_SRC";
export var INCOMPLETE_RULE = "INCOMPLETE_RULE";
export var INCOMPLETE_LHS = "INCOMPLETE_LHS";
export var INCOMPLETE_RHS = "INCOMPLETE_RHS";
export var BAD_MULTISELECT_VALUES = "BAD_MULTISELECT_VALUES";
export var BAD_SELECT_VALUE = "BAD_SELECT_VALUE";
export var INCORRECT_VALUE_TYPE = "INCORRECT_VALUE_TYPE";
export var INCORRECT_VALUE_JS_TYPE = "INCORRECT_VALUE_JS_TYPE";
export var VALUE_LENGTH_CONSTRAINT_FAIL = "VALUE_LENGTH_CONSTRAINT_FAIL";
export var VALUE_MIN_CONSTRAINT_FAIL = "VALUE_MIN_CONSTRAINT_FAIL";
export var VALUE_MAX_CONSTRAINT_FAIL = "VALUE_MAX_CONSTRAINT_FAIL";
export var NO_CONFIG_FOR_FIELD_VALUE = "NO_CONFIG_FOR_FIELD_VALUE";
export var CANT_COMPARE_FIELD_WITH_ITSELF = "CANT_COMPARE_FIELD_WITH_ITSELF";
export var CANT_COMPARE_FIELD_WITH_FIELD = "CANT_COMPARE_FIELD_WITH_FIELD";
export var INCORRECT_FIELD_TYPE = "INCORRECT_FIELD_TYPE";
export var UNSUPPORTED_FUNCTION_FOR_FIELD = "UNSUPPORTED_FUNCTION_FOR_FIELD";
export var REQUIRED_FUNCTION_ARG = "REQUIRED_FUNCTION_ARG";
export var INCORRECT_FUNCTION_RETURN_TYPE = "INCORRECT_FUNCTION_RETURN_TYPE";
export var INVALID_RANGE = "INVALID_RANGE";
export var ITEM_POSITION = "ITEM_POSITION";
export var ITEM_POSITION_ROOT = "ITEM_POSITION_ROOT";
export var ITEM_POSITION_WITH_INDEX_PATH = "ITEM_POSITION_WITH_INDEX_PATH";
export var ITEM_POSITION_IN_CASE = "ITEM_POSITION_IN_CASE";
export var _CONTEXT_MIN_MAX = "range";